import styled from "styled-components";

export const ModalCardContainer = styled.div`
  text-align: center;
  width: 70vw;
  height: auto;

  @media (min-width: 768px) {
    width: 500px;
    height: auto;
  }
  .img-modal {
    width: 100%;
  }
  h1 {
    color: #0ec977;
  }
  h3 {
    color: #380f52;
  }
`;
